var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.8571C10.5073 17.8571 10 19 7.91667 19C6.30584 19 5 17.9767 5 16.7143C5 15.4519 6 14.17 7.33333 13.4286C9.00321 12.5 9 10 12 10C15 10 15 12.5 16.6667 13.4286C18 14.1714 19 15.4519 19 16.7143C19 17.9767 17.6942 19 16.0833 19C14 19 13.4927 17.8571 12 17.8571Z",
    fill: "#2B323B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.75,
    cy: 10,
    rx: 1.75,
    ry: 2.5,
    fill: "#2B323B"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.75,
    cy: 6.5,
    rx: 1.75,
    ry: 2.5,
    fill: "#2B323B"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.25,
    cy: 6.5,
    rx: 1.75,
    ry: 2.5,
    fill: "#2B323B"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.25,
    cy: 10,
    rx: 1.75,
    ry: 2.5,
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimal);
export default __webpack_public_path__ + "static/media/animal.37020958d7dc3f8e6488caa3dfe861c5.svg";
export { ForwardRef as ReactComponent };